import * as conditionModules from '@/assets/mock/conditions';
import moment from 'moment';

export default class PolicyConditions {

	constructor() {}

	static get(options) {
		
		const {
			reportKey
		} = options;
		
		const searchList = conditionModules[reportKey]; // 1、动态渲染搜索组件； 2、同时结合searchForm传给后台
		const searchForm = {}; // 搜索表单
		const rules = {}; // 搜索表单验证
		
		searchList.map(ele => {
			switch(ele.type) {
				case "date":
					searchForm[ele.model] = ele.value ? moment(ele.value) : undefined;
					break;
				case "dates":
					if(ele.value && ele.value.length > 0) {
						searchForm[ele.model] = ele.value[0] && ele.value[1] ? [moment(ele.value[0]), moment(ele.value[1])] : undefined;
					} else {
						searchForm[ele.model] = undefined;
					}
					break;
				default:
					searchForm[ele.model] = ele.value || undefined;
			}
			rules[ele.model] = [{
				required: !!ele.required,
				message: `${ele.label}不能为空`,
				trigger: "blur"
			}]
		})
		
		return {
			searchList,
			searchForm,
			rules
		}
		
	}

}